import { CardholderSelection } from 'src/app/CardFeedDetails/components/AssignCardholderDropdown'
import { AssignmentRecipient } from 'src/component-modal/ConfirmCardAssignmentModal/ConfirmCardAssignmentModal'

/**
 * Maps the dropdown's `CardholderSelection` (member or new-contact email)
 * into the shape the confirmation modal expects. Used by both the bulk
 * flyout and the single-row cell path.
 */
export const toRecipient = (
  selection: CardholderSelection,
): AssignmentRecipient =>
  selection.kind === 'member'
    ? {
        email: selection.member.email,
        name: selection.member.fullNameOrEmail,
        avatarUrl: selection.member.avatarUrl,
        currentRole: selection.member.organizationRole,
      }
    : { email: selection.email, currentRole: null }
